/*  MUI  */
import { CircularProgress, Grid } from '@mui/material';

/*  React  */
import React from 'react';

export const LoadingPage = () => (
    <Grid
        container
        data-trackid="loadingPageContainer"
        sx={{
            backgroundColor: 'background.primary',
            height: '100%'
        }}
    >
        <Grid
            item
            xs={12}
            display="flex"
            alignItems="center"
            justifyContent="center"
        >
            <CircularProgress />
        </Grid>
    </Grid>
);
